import { Timeframe } from "../../models/enum/timeframe.enum";

export class ChartTimeFrameToTimeFrameMapper {
    static map(timeframe: Timeframe): string {
        switch (timeframe) {
            case Timeframe.OneMinute: {
                return '1m';
            }
            case Timeframe.TwoMinute: {
                return '2m';
            }
            case Timeframe.ThreeMinute: {
                return '3m';
            }
            case Timeframe.FiveMinute: {
                return '5m';
            }
            case Timeframe.TenMinute: {
                return '10m';
            }
            case Timeframe.FifteenMinute: {
                return '15m';
            }
            case Timeframe.ThirtyMinute: {
                return '30m';
            }
            case Timeframe.SixtyMinute: {
                return '60m';
            }
            case Timeframe.Day: {
                return '1D';
            }
            case Timeframe.Week: {
                return '1W';
            }
            case Timeframe.Month: {
                return '1Month';
            }
            case Timeframe.OneMonthRange: {
                return '1D';
            }
            case Timeframe.SixMonthRange: {
                return '1D';
            }
            case Timeframe.YearToDateRange: {
                return '1D';
            }
            case Timeframe.OneYearRange: {
                return '1D';
            }
            case Timeframe.FiveYearRange: {
                return '1M';
            }
            default: {
                throw  new Error(`timeframe string not supported yet: ${timeframe}`);
            }
        }
    }
}